import { render } from "./index.vue?vue&type=template&id=66967b26&bindings={}"
import script from "./select-list.js?vue&type=script&lang=js"
export * from "./select-list.js?vue&type=script&lang=js"

import "./select-list.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script